import path from 'node:path'
import type { CreateSchemaKind } from '@cli-types/core-engine/commands.js'

export function schemaFilePath(
  kind: CreateSchemaKind,
  schemasDir: string,
  schemaName: string
): string {
  return kind === 'form'
    ? path.join(schemasDir, 'forms', `${schemaName}.json`)
    : path.join(schemasDir, `${schemaName}.json`)
}
